export default __webpack_public_path__ + "static/Continuous Integration 8_0-30f6cac2bfc60bb48053bacb0b65ed34.png";